import { CheckCircle, Loader2, AlertCircle, Cloud } from "lucide-react";
import { cn } from "@/lib/utils";

type SaveStatus = "idle" | "saving" | "saved" | "error";

interface AutoSaveIndicatorProps {
  status: SaveStatus;
  lastSavedAt?: Date | null;
  className?: string;
}

export function AutoSaveIndicator({ status, lastSavedAt, className }: AutoSaveIndicatorProps) {
  const formatTime = (date: Date) => {
    return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  };

  return (
    <div
      className={cn(
        "flex items-center gap-1.5 text-xs transition-opacity duration-300",
        className
      )}
    >
      {status === "saving" && (
        <>
          <Loader2 className="h-3.5 w-3.5 animate-spin text-muted-foreground" />
          <span className="text-muted-foreground">Saving...</span>
        </>
      )}
      {status === "saved" && (
        <>
          <CheckCircle className="h-3.5 w-3.5 text-emerald-500" />
          <span className="text-emerald-600">Saved</span>
        </>
      )}
      {status === "error" && (
        <>
          <AlertCircle className="h-3.5 w-3.5 text-destructive" />
          <span className="text-destructive">Save failed</span>
        </>
      )}
      {status === "idle" && lastSavedAt && (
        <>
          <Cloud className="h-3.5 w-3.5 text-muted-foreground" />
          <span className="text-muted-foreground">
            Saved at {formatTime(lastSavedAt)}
          </span>
        </>
      )}
      {status === "idle" && !lastSavedAt && (
        <>
          <Cloud className="h-3.5 w-3.5 text-muted-foreground" />
          <span className="text-muted-foreground">Auto-save enabled</span>
        </>
      )}
    </div>
  );
}
